import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import moment from 'moment';

import { BaseUI } from '../../base.ui';
import { Client } from '../../../domain/data';
import {
    ClientRelation,
    ClientType,
    DocumentType,
    GetClientByDocumentUseCase,
    GetLegalDisclaimerUseCase,
    LegalGuardianType,
    Nature,
} from '../../../../core';
import { ErrorDialog } from '../../dialog/error/error.dialog';
import { LegalDialog } from '../../dialog/legal/legal.dialog';
import { ParentEvents } from '../../../utils/parent-events.service';

import { environment } from '../../../../../environments/environment';

@Component({
    selector: 'thr-contract-form-participant-minor-disabled-person',
    templateUrl: './contract-form-participant-minor-disabled-person.component.html',
    styleUrls: ['./contract-form-participant-minor-disabled-person.component.scss'],
})
export class ContractFormParticipantMinorDisabledPersonComponent extends BaseUI implements AfterViewInit, OnDestroy, OnInit {
    public ClientRelation: typeof ClientRelation = ClientRelation;
    public ClientType: typeof ClientType = ClientType;
    public DocumentType: typeof DocumentType = DocumentType;

    public isAddingTutor = false;
    public today = moment();
    public hundredYears = moment().subtract(100, 'years');
    public currentTutor: Client;
    public selectedTutors: { [key: number]: boolean } = {};
    public isClientPortal = environment.portalClient;

    @Input()
    client: Client;

    @Input()
    isFirst = false;

    @Input()
    tutors: Client[];

    @Output()
    addingTutor: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(
        parentEvents: ParentEvents,
        private dialog: MatDialog,
        private getClientByDocumentUseCase: GetClientByDocumentUseCase,
        private getLegalDisclaimerUseCase: GetLegalDisclaimerUseCase
    ) {
        super(parentEvents);
    }

    get isTutorChecked(): boolean {
        let isTutorChecked = false;

        Object.keys(this.selectedTutors).map((it) => (this.selectedTutors[it] ? (isTutorChecked = true) : null));

        return isTutorChecked;
    }

    ngOnInit() {
        if (!this.tutors || this.tutors.length === 0) {
            if (this.client.legalGuardians.length === 0) {
                this.createTutor();
            } else {
                this.editFirstTutor();
            }
        } else if (this.client) {
            this.client.legalGuardians.map((it) => (this.selectedTutors[String(it.id)] = true));

            this.isAddingTutor = false;
            this.addingTutor.emit(this.isAddingTutor);
        }
    }

    private createTutor() {
        this.isAddingTutor = true;
        this.addingTutor.emit(this.isAddingTutor);

        this.currentTutor = new Client();
        this.currentTutor.docExpirationDatePermanent = false;
        this.currentTutor.phoneExonerate = false;
        this.currentTutor.emailExonerate = false;
        this.currentTutor.nature = Nature.NATURAL;
        this.currentTutor.type = ClientType.NATURAL_PERSON;
        this.currentTutor.legalGuardianType = LegalGuardianType.TUTOR;
        this.currentTutor.legalGuardianRelation = ClientRelation.HOLDER;

        this.client.addLegalGuardian(this.currentTutor);
    }

    private editFirstTutor() {
        this.isAddingTutor = true;
        this.addingTutor.emit(this.isAddingTutor);

        this.currentTutor = this.client.legalGuardians[0];
    }

    onDocumentBlur() {
        if (!this.isClientPortal && !this.isFirst && !!this.client.docId) {
            this.getClientByDocumentUseCase
                .bind({
                    docType: this.client.docType,
                    docId: this.client.docId,
                })
                .subscribe((transaction) => {
                    if (transaction.isSuccess) {
                        this.client.copy(transaction.data);
                        this.client.acceptLegal = true;
                        this.client.disabled = true;
                        this.parentEvents.resize();
                    }
                });
        }
    }

    onExonerate() {
        this.parentEvents.resize();
    }

    onAddTutor() {
        this.createTutor();
    }

    onTutorChecked(tutor: Client, checked: boolean) {
        if (checked) {
            tutor.legalGuardianType = LegalGuardianType.TUTOR;
            this.client.addLegalGuardian(tutor);
        } else {
            this.client.removeLegalGuardian(tutor);
        }
    }

    openDialog() {
        this.getLegalDisclaimerUseCase.bind().subscribe((transaction) => {
            if (transaction.isSuccess) {
                this.dialog.open(LegalDialog, {
                    data: {
                        text: transaction.data,
                        title: 'dialog.info-rgpd-title',
                        ok: 'general.close',
                    },
                });
            } else if (!transaction.isAuthError) {
                this.dialog.open(ErrorDialog);
            }
        });
    }
}
